import { SessionActorType } from "doxecure-commons/lib/doxecureTypes";

import { Dashboard } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";

export const CanceledDocumentsView = () => {
    const { connectedProfileId } = useAuthContext();
    optlog(`+++ CanceledDocumentsView initialized with profile ID '${connectedProfileId}'`) ;

    return okOrError(
        connectedProfileId,
        (<Dashboard 
            title="Documents résiliés"
            emptyMessage="Pas de documents résiliés"
            category="canceled"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor, SessionActorType.Approver, SessionActorType.Signer]} 
            sectionInfos={defaultSectionInformations} 
        />),
        false,
        "Impossible d'afficher la liste des documents résiliés, car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;
};
